import { Kitchen } from './Kitchen';
export default Kitchen;